import { css } from 'styled-components';

const publicUrl = process.env.PUBLIC_URL;

export default css`
  @font-face {
    font-family: 'Infra';
    src: url('${publicUrl}/fonts/infra-light.WOFF') format('woff');
    font-weight: 200;
    font-style: normal;
  }

  @font-face {
    font-family: 'Infra';
    src: url('${publicUrl}/fonts/infra-regular.WOFF') format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Infra';
    src: url('${publicUrl}/fonts/infra-medium.WOFF') format('woff');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Infra';
    src: url('${publicUrl}/fonts/infra-semiBold.WOFF') format('woff');
    font-weight: 600;
    font-style: normal;
  }
`;
